import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Dots } from "@zendeskgarden/react-loaders";
// @ts-ignore
import { client } from "filestack-react";
import { AlertService } from "../../services/alert.service";
import service from "../../services/api.service";
import FileStackService from "../../services/filestack.service";
import styles from './index.module.scss';
import TranslationService, { t } from "../../translations/translation.service";

// Campos que o autopreenchimento tenta extrair; o formulário avisa no campo
// que o currículo não trouxe.
export const CV_AUTOFILL_FIELDS = ['name', 'lastName', 'email', 'phone', 'location'];

export interface CvUploadAutoFillProps {
  onExtractedData: (data: any) => void;
  onError: (msg: string) => void;
  buttonText?: string;
  unauthenticated?: boolean;
}

const CvUploadAutoFill: React.FC<CvUploadAutoFillProps> = ({
  onExtractedData,
  onError,
  buttonText = t("Autopreenchimento via Currículo"),
  unauthenticated = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);

  const uploadCv = async (file: File) => {
    const pickSecurity = (await FileStackService.getPoliceAndSignature()).data;
    const fileStackClient = client.init(process.env.REACT_APP_FILESTACK_API, {
      security: { policy: pickSecurity.policy, signature: pickSecurity.signature }
    });
    const uploaded = await fileStackClient.upload(file);
    const readSecurity = unauthenticated
      ? await FileStackService.getFileStackSecreteCodeToUserSignup(uploaded.url, false)
      : await FileStackService.getFileStackSecreteCodeToUser(uploaded.url, false);

    return {
      fileName: file.name,
      files: [{ fileName: file.name, url: uploaded.url }],
      policyAndSignature: readSecurity.data
    };
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file || loading) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("language", TranslationService.getCurrentLanguage());

    try {
      const response = await service.post("/resume/extract", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      const data = response.data;

      let attachment = {};
      try {
        attachment = await uploadCv(file);
      } catch (uploadErr: any) {
        console.error("Exceção ao anexar o currículo automaticamente:", uploadErr);
        AlertService.error(t("Não foi possível anexar o currículo automaticamente. Anexe o arquivo manualmente."));
      }

      const missingFields = CV_AUTOFILL_FIELDS.filter(field => !data[field]);

      onExtractedData({ ...data, ...attachment, missingFields });
      AlertService.success("Dados extraídos do currículo e preenchidos automaticamente!");
    } catch (err: any) {
      console.error("Exceção ao extrair dados do currículo:", err);
      onError("Não foi possível processar o arquivo. Verifique o formato e tente novamente.");
      AlertService.error("Não foi possível processar o arquivo. Verifique o formato e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['cv-upload-container']}>
      <Button
        className={styles['add-cv-btn']}
        onClick={() => fileInputRef.current?.click()}
        disabled={loading}
        aria-busy={loading}
      >
        {loading ? (
          <span className={styles['loading-content']}>
            <Dots size="14px" color="#fff" />
            {t("Lendo currículo...")}
          </span>
        ) : (
          buttonText
        )}
      </Button>
      <input
        type="file"
        accept=".pdf,.docx"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={loading}
      />
    </div>
  );
};

export default CvUploadAutoFill;